import classNames from "classnames";

import { cyberDisciplinesCards } from "../CyberContainer/data";
import { DisciplinesCard } from "../DisciplinesClassic";
import s from "./DisciplinesCyber.module.scss";


export default function DisciplinesCyber() {
  return (
      <section className={classNames('section', s.disciplines)}>
          <div className="wrapper">
              <div className="anchor-place" id="disciplines"></div>
              <h2 className="section__title">КЕЙСЫ</h2>
              <ul className={s.disciplinesList}>
                  {cyberDisciplinesCards.map((card) => (
                      <DisciplinesCard card={card} routePrefix="/cyber/" />
                  ))}
              </ul>
          </div>
      </section>
  );
}
